import React, { Fragment } from 'react';
import { Separator } from '../separator';
import { Button, LinkButton } from '../button';
import * as styles from './card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Card = _ref => {
  var children = _ref.children,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? '' : _ref$action,
    href = _ref.href,
    onClick = _ref.onClick,
    className = _ref.className;
  var showFooter = action || href;
  return ___EmotionJSX("section", {
    css: styles.card({
      hasOnClick: Boolean(onClick)
    }),
    className: className,
    onClick: onClick
  }, ___EmotionJSX("div", {
    css: styles.content
  }, children), showFooter && ___EmotionJSX(Fragment, null, ___EmotionJSX(Separator, null), ___EmotionJSX("div", {
    css: styles.footer
  }, href ? ___EmotionJSX(LinkButton, {
    stretched: true,
    css: styles.action,
    appearance: "ghost",
    href: href
  }, action) : ___EmotionJSX(Button, {
    stretched: true,
    css: styles.action,
    appearance: "ghost"
  }, action))));
};
export default Card;